import { apiConfig } from "./apiConfig";

const submitUrl = apiConfig.oftheday.submit;

export const postSubmit = (axios, payload) => axios.post(`${submitUrl}`, payload);
export const editPostSubmit = (axios, payload) => axios.put(`${submitUrl}`, payload);
